import type { OfferDetails, SamplePage } from "../types/offer";

/**
 * DATOS COMERCIALES — completá los campos en null.
 * Mientras estén en null, la página muestra un aviso "Pendiente" en lugar de inventar el dato.
 */
export const offer: OfferDetails = {
  packageName: "Tu iPhone, Tu Estudio + 5 bonos",
  price: "27 USD",
  previousPrice: null,
  savings: null,
  paymentTerms: "Pago único",
  priceNote: "Tranquilo, vas a pagar en tu moneda local.",
  checkoutUrl: "https://cns-digital-guias-para-tu-iphone.impultienda.ar/checkout",
  guarantee: {
    title: "Garantía de 10 días",
    terms:
      "Si en los primeros 10 días el material no te gusta o no te sirve, te devolvemos el dinero. Quedate tranquilo.",
  },
  paymentMethods: [],
  delivery: "Lo recibís de inmediato por email: todo el material en PDF.",
  contactEmail: null,
  whatsapp: null,
  instagramUrl: "https://www.instagram.com/celularesnuevossaavedra/",
};

/** Páginas interiores reales del libro */
export const samplePages: SamplePage[] = [
  {
    src: "https://cdn.magicpatterns.com/uploads/bBunBJ5AttEgTyP9YEB4bz/01_portada.png",
    alt: "Portada interior de Tu iPhone, Tu Estudio",
    caption: "Portada del libro",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/n41BvGL39hQjbJ3ovoyjQv/02_antes_despues.png",
    alt: "Página Antes y después: tu producto merece mostrarse mejor",
    caption: "Antes y después + los 8 pasos del libro",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/gRLE7o9infvnphmXF3NWcC/03_comida_reposteria.png",
    alt: "Página Comida y repostería con tres ángulos de cámara",
    caption: "Comida y repostería: tres ángulos",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/n3epaHHZRzhRuKmrrBqqtx/04_cinco_tomas.png",
    alt: "Página Cinco tomas para mostrar tu producto",
    caption: "Cinco tomas para mostrar tu producto",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/d5FQPHcn2aME7Ry6zzipcW/05_edicion_sin_exagerar.png",
    alt: "Página Mejorá sin exagerar sobre edición de fotos",
    caption: "Edición: mejorá sin exagerar",
  },
];
